<template>
    <div v-scroll id="app" ref="app" :style="backgroundStyles">
        <div class="section col web" id="landing-section">
            <div class="course-bgd web col">
                <div class="navbar-wrapper">
                    <Navbar v-bind:white="true" />
                </div>
                <div class="course-landing row-wrap">
                    <div class="course-info web">
                        <h1 class="title">Rate {{ name }}</h1>
                    </div>
                </div>
            </div>
            <div class="course-bgd-footer web" />
        </div>

        <div class="section mobile">
            <div class="course-bgd mobile col">
                <div class="navbar-wrapper">
                    <Navbar v-bind:white="true" @menu-click="onMenuClick" />
                </div>
                <div class="course-info mobile">
                    <h1 class="title">Rate {{ name }}</h1>
                </div>
            </div>
        </div>

        <div class="page-body-grid section">
            <div class="page-body-item">
                <div id="all-metrics-input">
                    <article id="overall" class="message single-metric-input" @click="openAccordion('overall')">
                        <MetricDescriptionCard
                            selector="#overall"
                            title="Overall experience"
                            description="What was your overall experience with this course?"
                            icon="overall"
                            :completed="overallComplete"
                            v-on:updateStars="updateStars('overall', $event)"
                        />
                        <div
                            id="overall-accordion"
                            class="message-body is-collapsible accordion"
                            data-parent="all-metrics-input"
                        >
                            <div class="message-body-content">
                                <div class="divider"></div>
                                <div class="question">
                                    <p>When did you take this course?</p>
                                    <div class="tags-response">
                                        <div>
                                            <button
                                                class="tag"
                                                @click="overall.year = 1"
                                                :class="{ active: overall.year == 1 }"
                                            >
                                                2020
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.year = 2"
                                                :class="{ active: overall.year == 2 }"
                                            >
                                                2019
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.year = 3"
                                                :class="{ active: overall.year == 3 }"
                                            >
                                                2018
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.year = 4"
                                                :class="{ active: overall.year == 4 }"
                                            >
                                                2017
                                            </button>
                                            <span style="width:40px"></span>
                                            <button
                                                class="tag"
                                                @click="overall.quarter = 1"
                                                :class="{ active: overall.quarter == 1 }"
                                            >
                                                Fall
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.quarter = 2"
                                                :class="{ active: overall.quarter == 2 }"
                                            >
                                                Winter
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.quarter = 3"
                                                :class="{ active: overall.quarter == 3 }"
                                            >
                                                Spring
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.quarter = 4"
                                                :class="{ active: overall.quarter == 4 }"
                                            >
                                                Summer
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <div class="question">
                                    <p>Which professor did you take the course with?</p>
                                    <div class="tags-response">
                                        <div>
                                            <button
                                                v-for="(prof, index) in professors"
                                                :key="'professor-' + index"
                                                class="tag"
                                                @click="overall.professor = index"
                                                :class="{ active: overall.professor == index }"
                                            >
                                                {{ prof.name }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <div class="question">
                                    <p>
                                        What grade did you receive in this course?
                                        <span class="instruction"> Your response will be anonymous </span>
                                    </p>
                                    <div class="tags-response">
                                        <div>
                                            <button
                                                class="tag"
                                                @click="overall.grade = 1"
                                                :class="{ active: overall.grade == 1 }"
                                            >
                                                &lt; 2.0
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.grade = 2"
                                                :class="{ active: overall.grade == 2 }"
                                            >
                                                2.0 - 2.5
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.grade = 3"
                                                :class="{ active: overall.grade == 3 }"
                                            >
                                                2.5 - 3.0
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.grade = 4"
                                                :class="{ active: overall.grade == 4 }"
                                            >
                                                3.0 - 3.5
                                            </button>
                                            <button
                                                class="tag"
                                                @click="overall.grade = 5"
                                                :class="{ active: overall.grade == 5 }"
                                            >
                                                3.5 - 4.0
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    <article id="workload" class="message single-metric-input" @click="openAccordion('workload')">
                        <MetricDescriptionCard
                            selector="#workload"
                            title="Workload"
                            description="How would you rate your course workload?"
                            icon="workload"
                            :completed="workloadComplete"
                            v-on:updateStars="updateStars('workload', $event)"
                        />
                        <div
                            id="workload-accordion"
                            class="message-body is-collapsible accordion"
                            data-parent="all-metrics-input"
                        >
                            <div class="message-body-content">
                                <div class="divider"></div>
                                <div class="question">
                                    <p>How many hours did you spend on this course every week?</p>
                                    <div class="tags-response">
                                        <span
                                            ><input
                                                id="hours-per-week-input"
                                                v-model="workload.hours"
                                                @input="handleHoursPerWeek"
                                                type="number"
                                                min="0"
                                                max="25"
                                            />
                                            hours per week</span
                                        >
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <div class="question">
                                    <p>
                                        What did you spend your time doing?
                                        <span class="instruction"> You may select multiple </span>
                                    </p>
                                    <div class="tags-response">
                                        <div>
                                            <button
                                                v-for="(workTag, index) in workload.workTags"
                                                :key="'work-tag-' + index"
                                                @click="toggleWorkloadWorkTag(index)"
                                                :class="{ tag: true, active: workload.selectedWorkTags.has(index) }"
                                            >
                                                {{ workTag }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    <article id="difficulty" class="message single-metric-input" @click="openAccordion('difficulty')">
                        <MetricDescriptionCard
                            selector="#difficulty"
                            title="Difficulty"
                            description="How difficult did you find this course?"
                            subheading="Scale from Very Easy (1 star) to Very Difficult (5 stars)"
                            icon="difficulty"
                            :completed="difficultyComplete"
                            v-on:updateStars="updateStars('difficulty', $event)"
                        />
                        <div
                            id="difficulty-accordion"
                            class="message-body is-collapsible accordion"
                            data-parent="all-metrics-input"
                            v-if="rating.difficulty != 3"
                        >
                            <div class="message-body-content">
                                <div class="divider"></div>
                                <div class="question" v-if="rating.difficulty < 3">
                                    <p>
                                        What made this course chill? <span class="optional-tag"> optional </span>
                                        <span class="instruction" v-if="difficulty.comment">
                                            {{ 125 - difficulty.comment.length }} characters remaining
                                        </span>
                                    </p>
                                    <div class="chill">
                                        <div class="description">
                                            <i class="far fa-thumbs-up"></i>
                                            <span class="thumbs-up"> Chill </span>
                                            <i class="far fa-thumbs-down"></i>
                                            <span class="thumbs-down"> Rough </span>
                                        </div>
                                        <div class="justification">
                                            <i class="fas fa-quote-left"></i>
                                            <div>
                                                <input
                                                    type="text"
                                                    v-model="difficulty.comment"
                                                    maxlength="125"
                                                    placeholder="Enter a one line justification"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="question" v-else-if="rating.difficulty > 3">
                                    <p>
                                        What made this course rough? <span class="optional-tag"> optional </span>
                                        <span class="instruction" v-if="difficulty.comment">
                                            {{ 125 - difficulty.comment.length }} characters remaining
                                        </span>
                                    </p>
                                    <div class="rough">
                                        <div class="description">
                                            <i class="far fa-thumbs-up"></i>
                                            <span class="thumbs-up"> Chill </span>
                                            <i class="far fa-thumbs-down"></i>
                                            <span class="thumbs-down"> Rough </span>
                                        </div>
                                        <div class="justification">
                                            <i class="fas fa-quote-left"></i>
                                            <div>
                                                <input
                                                    type="text"
                                                    v-model="difficulty.comment"
                                                    maxlength="125"
                                                    placeholder="Enter a one line justification"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    <article id="professor" class="message single-metric-input" @click="openAccordion('professor')">
                        <MetricDescriptionCard
                            selector="#professor"
                            :title="professorCollabsibleName"
                            description="How would you rate this professor?"
                            subheading="Scale from Terrible (1 star) to Excellent (5 stars)"
                            icon="professor"
                            :completed="professorComplete"
                            v-on:updateStars="updateStars('professor', $event)"
                        />
                        <div
                            id="professor-accordion"
                            class="message-body is-collapsible accordion"
                            data-parent="all-metrics-input"
                        >
                            <div class="message-body-content">
                                <div class="divider" v-if="rating.professor != 3"></div>
                                <div class="question" v-if="rating.professor > 3">
                                    <p>
                                        What made {{ professorName }} chill?
                                        <span class="optional-tag"> optional </span>
                                        <span class="instruction" v-if="professor.comment">
                                            {{ 125 - professor.comment.length }} characters remaining
                                        </span>
                                    </p>
                                    <div class="chill">
                                        <div class="description">
                                            <i class="far fa-thumbs-up"></i>
                                            <span class="thumbs-up"> Chill </span>
                                            <i class="far fa-thumbs-down"></i>
                                            <span class="thumbs-down"> Rough </span>
                                        </div>
                                        <div class="justification">
                                            <i class="fas fa-quote-left"></i>
                                            <div>
                                                <input
                                                    type="text"
                                                    v-model="professor.comment"
                                                    maxlength="125"
                                                    placeholder="Enter a one line justification"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="question" v-else-if="rating.professor != 3">
                                    <p>
                                        What made {{ professorName }} rough?
                                        <span class="optional-tag"> optional </span>
                                        <span class="instruction" v-if="professor.comment">
                                            {{ 125 - professor.comment.length }} characters remaining
                                        </span>
                                    </p>
                                    <div class="rough">
                                        <div class="description">
                                            <i class="far fa-thumbs-up"></i>
                                            <span class="thumbs-up"> Chill </span>
                                            <i class="far fa-thumbs-down"></i>
                                            <span class="thumbs-down"> Rough </span>
                                        </div>
                                        <div class="justification">
                                            <i class="fas fa-quote-left"></i>
                                            <div>
                                                <input
                                                    type="text"
                                                    v-model="professor.comment"
                                                    maxlength="125"
                                                    placeholder="Enter your a line justification"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <div class="question">
                                    <div class="question-posing-container">
                                        <p>
                                            Select 3 tags that best describe this professor
                                            <span class="optional-tag"> optional </span>
                                        </p>
                                    </div>
                                    <div class="tags-response">
                                        <div>
                                            <button
                                                v-for="(qualityTag, index) in professor.qualityTags"
                                                :key="'quality-tag-' + index"
                                                @click="toggleProfessorQualityTag(index)"
                                                :class="{ tag: true, active: professor.selectedQualityTags.has(index) }"
                                            >
                                                {{ qualityTag }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    <article id="relevance" class="message single-metric-input" @click="openAccordion('relevance')">
                        <MetricDescriptionCard
                            selector="#relevance"
                            title="Relevance"
                            description="How useful did you find this course for your future career?"
                            icon="relevance"
                            :completed="relevanceComplete"
                            v-on:updateStars="updateStars('relevance', $event)"
                        />
                        <div
                            id="relevance-accordion"
                            class="message-body is-collapsible accordion"
                            data-parent="all-metrics-input"
                        >
                            <div class="message-body-content">
                                <div class="divider"></div>
                                <div class="question">
                                    <p>
                                        What jobs are related to the course material?
                                        <span class="instruction"> You may select multiple </span>
                                        <span class="optional-tag"> optional </span>
                                    </p>
                                    <div class="tags-response">
                                        <div>
                                            <button
                                                v-for="(jobTag, index) in relevance.jobTags"
                                                :key="'job-tag-' + index"
                                                @click="toggleRelevanceJobTag(index)"
                                                :class="{ tag: true, active: relevance.selectedJobTags.has(index) }"
                                            >
                                                {{ jobTag }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <div class="question">
                                    <div class="question-posing-container">
                                        <p>
                                            How does this course help with applying for jobs?
                                            <span class="instruction"> You may select multiple </span>
                                            <span class="optional-tag"> optional </span>
                                        </p>
                                    </div>
                                    <div class="tags-response">
                                        <div>
                                            <button
                                                v-for="(skillTag, index) in relevance.skillTags"
                                                :key="'skill-tag-' + index"
                                                @click="toggleRelevanceSkillTag(index)"
                                                :class="{ tag: true, active: relevance.selectedSkillTags.has(index) }"
                                            >
                                                {{ skillTag }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </article>
                    <article id="comments" class="message single-metric-input" @click="openAccordion('comments')">
                        <MetricDescriptionCard selector="#comments" title="Comments" icon="comment" hideStars />
                        <div id="comments-accordion" class="message-body accordion" data-parent="all-metrics-input">
                            <div class="message-body-content">
                                <div class="divider"></div>
                                <div class="question">
                                    <p>Overall course review</p>
                                    <input
                                        type="text"
                                        v-model="comments.overallComment"
                                        placeholder="Enter your overall course review"
                                    />
                                </div>
                                <br />
                                <div class="question">
                                    <p>What advice will you give to people taking this course?</p>
                                    <input
                                        type="text"
                                        v-model="comments.adviceComment"
                                        placeholder="Enter your advice"
                                    />
                                </div>
                                <br />
<!--
                                <div class="question">
                                    <p>
                                        Your <strong>uw.edu</strong> email address.<span class="instruction"
                                            >(We’ll email you $1 for this review)</span
                                        >
                                    </p>
                                    <input type="email" v-model="email" placeholder="Enter your email" />
                                </div>
-->
                            </div>
                        </div>
                    </article>
                </div>
            </div>
            <div>
                <div id="progress-status">
                    <div>
                        <div class="progress-status-top">
                            <span> {{ percentage }} % </span> complete
                        </div>
                        <div class="icon-container">
                            <div :class="{ incomplete: !overallComplete }">
                                <img src="@/assets/icons/metrics/overall-icon.svg" />
                            </div>
                            <div :class="{ incomplete: !workloadComplete }">
                                <img src="@/assets/icons/metrics/workload-icon.svg" />
                            </div>
                            <div :class="{ incomplete: !difficultyComplete }">
                                <img src="@/assets/icons/metrics/difficulty-icon.svg" />
                            </div>
                            <div :class="{ incomplete: !professorComplete }">
                                <img src="@/assets/icons/metrics/professor-icon.svg" />
                            </div>
                            <div :class="{ incomplete: !relevanceComplete }">
                                <img src="@/assets/icons/metrics/relevance-icon.svg" />
                            </div>
                            <div :class="{ incomplete: !commentsComplete }">
                                <img src="@/assets/icons/metrics/comment-icon.svg" />
                            </div>
                        </div>
                    </div>
                    <button class="submit-form" :disabled="submitDisabled" @click="submit">Submit</button>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Navbar from "@/components/navigation/Navbar";
import Footer from "@/components/navigation/Footer";
import MetricDescriptionCard from "@/components/cards/MetricDescriptionCard";
import bulmaCollapsible from "@creativebulma/bulma-collapsible";
import { firestore, auth } from "@/firebase.js";

export default {
    // This is the name of our component
    name: "RatePage",

    // This is all of the components that we use
    components: {
        Navbar,
        Footer,
        MetricDescriptionCard,
    },

    data() {
        return {
            onMenuClick: this.toggleMenuStyles,
            id: null,
            email: null,
            user: null,

            rating: {
                overall: 0,
                workload: 0,
                difficulty: 0,
                professor: 0,
                relevance: 0,
            },

            // Represents the overall data
            overall: {
                year: null,
                quarter: null,
                professor: null,
                grade: null,
            },

            // Represents the workload data
            workload: {
                hours: null,
                workTags: ["Homework", "Lectures", "Section", "Readings", "Office Hours", "Tests", "Other"],
                selectedWorkTags: new Set(),
                selectedSize: 0,
            },

            // Represents the relevance data
            difficulty: {
                comment: null,
            },

            // Represents the relevance data
            relevance: {
                jobTags: [
                    "Software Engineer",
                    "Systems Engineer",
                    "Hardware Engineer",
                    "Data Scientist",
                    "Researcher",
                    "Not relevant",
                ],
                selectedJobTags: new Set(),
                skillTags: [
                    "Improved at interviewing",
                    "Helped with side projects",
                    "Sharpened fundamentals",
                    "Highly industry relevant",
                ],
                selectedSkillTags: new Set(),
            },

            // Represents the professor data
            professor: {
                comment: null,
                qualityTags: [
                    "Eager to help",
                    "Easy grader",
                    "Explains concepts easily",
                    "Extra credit opportunity",
                    "Energetic",
                    "Caring",
                    "Boring lectures",
                    "Very demanding",
                    "Harsh grader",
                    "Hard to follow along",
                    "Lots of busy work",
                ],
                selectedQualityTags: new Set(),
            },

            // Represents the data for the comments
            comments: {
                overallComment: null,
                adviceComment: null,
            },

            name: "a course",
            professors: [],
            menuOpen: false,
            collapsibles: [],
        };
    },

    computed: {
        // TODO: Update color
        backgroundStyles() {
            return { "--bgd-color": "#FBA888" };
        },

        professorName() {
            if (this.overall.professor === null) {
                return "that professor";
            }
            return this.professors[this.overall.professor].name;
        },

        professorCollabsibleName() {
            if (this.overall.professor === null) {
                return "Professor";
            }
            return "Professor: " + this.professors[this.overall.professor].name;
        },

        overallComplete() {
            let overall = this.overall;
            return (
                this.rating.overall > 0 &&
                overall.year !== null &&
                overall.professor !== null &&
                overall.quarter !== null &&
                overall.grade !== null &&
                this.auth !== null
            );
        },

        workloadComplete() {
            let workload = this.workload;
            return this.rating.workload > 0 && workload.hours !== null && workload.selectedSize > 0;
        },

        difficultyComplete() {
            return this.rating.difficulty > 0;
        },

        professorComplete() {
            return this.rating.professor > 0;
        },

        relevanceComplete() {
            return this.rating.relevance > 0;
        },

        commentsComplete() {
            return (
                this.comments.overallComment !== null &&
                this.comments.adviceComment !== null
//                &&
//                this.email !== null &&
//                this.email.trim().endsWith("uw.edu")
            );
        },

        percentage() {
            let a = this.overallComplete ? 1 : 0;
            let b = this.workloadComplete ? 1 : 0;
            let c = this.difficultyComplete ? 1 : 0;
            let d = this.professorComplete ? 1 : 0;
            let e = this.relevanceComplete ? 1 : 0;
            let f = this.commentsComplete ? 1 : 0;

            return ((100 * (a + b + c + d + e + f)) / 6).toFixed(0);
        },

        submitDisabled() {
            return (
                !this.overallComplete ||
                !this.workloadComplete ||
                !this.difficultyComplete ||
                !this.professorComplete ||
                !this.relevanceComplete ||
                !this.commentsComplete
            );
        },
    },

    methods: {
        toggleMenuStyles(isOpen) {
            this.menuOpen = isOpen;
        },

        updateStars(name, value) {
            this.rating[name] = value;

            let arr = ["overall", "workload", "difficulty", "professor", "relevance"];
            let index = arr.indexOf(name);
            if (index < 0) {
                console.log("Error! Couldn't find: " + name);
                return;
            }

            // Do not expand in certain cases
            if (name == "relevance" && value <= 2) {
                return;
            }

            this.collapsibles[index].expand();
        },

        toggleRelevanceJobTag(index) {
            let set = this.relevance.selectedJobTags;
            if (set.has(index)) {
                set.delete(index);
            } else {
                if (index == 5) {
                    // Labeled as not relevant
                    set.clear();
                } else {
                    set.delete(5); // Make sure it is relevant
                }
                set.add(index);
            }
            this.$forceUpdate();
        },

        toggleRelevanceSkillTag(index) {
            let set = this.relevance.selectedSkillTags;
            if (set.has(index)) {
                set.delete(index);
            } else {
                set.add(index);
            }
            this.$forceUpdate();
        },

        toggleProfessorQualityTag(index) {
            let set = this.professor.selectedQualityTags;
            if (set.has(index)) {
                set.delete(index);
                this.$forceUpdate();
            } else if (set.size < 3) {
                set.add(index);
                this.$forceUpdate();
            }
        },

        toggleWorkloadWorkTag(index) {
            let set = this.workload.selectedWorkTags;
            if (set.has(index)) {
                set.delete(index);
                this.workload.selectedSize--;
            } else {
                set.add(index);
                this.workload.selectedSize++;
            }
            console.log(set);
            this.$forceUpdate();
        },

        openAccordion(name) {
            if (name === "comments" || this.rating[name] > 0) {
                let arr = ["overall", "workload", "difficulty", "professor", "relevance"];
                let index = arr.indexOf(name);
                if (index < 0) {
                    console.log("Error! Couldn't find: " + name);
                    return;
                }

                // Do not expand in certain cases
                if (name == "relevance" && this.rating[name] <= 2) {
                    return;
                }

                this.collapsibles[index].expand();
            }
        },
        closeAccordion(name) {
            let arr = ["overall", "workload", "difficulty", "professor", "relevance"];
            let index = arr.indexOf(name);
            if (index < 0) {
                console.log("Error! Couldn't find: " + name);
                return;
            }

            this.collapsibles[index].close();
        },

        parseToInt(val) {
            if (typeof val === "number") {
                return val;
            }
            return parseInt(val);
        },

        computeFormData() {
            let obj = {
                version: 2,

                // Authentication
                auth: this.user.uid,
                email: this.user.email,
                name: this.user.displayName,

                date: null,
                course: this.$router.currentRoute.params.course,
                hours: this.parseToInt(this.workload.hours),
                professor: this.professors[this.overall.professor].name,
                professors: [this.professors[this.overall.professor].professorId],

                rating: this.rating,
                overall: this.overall,

                workload: {
                    hours: this.parseToInt(this.workload.hours),
                    workTags: this.getDistributionObject(
                        this.workload.workTags,
                        Array.from(this.workload.selectedWorkTags)
                    ),
                },

                difficulty: this.difficulty,

                relevance: {
                    jobTags: this.getDistributionObject(
                        this.relevance.jobTags,
                        Array.from(this.relevance.selectedJobTags)
                    ),
                    skillTags: this.getDistributionObject(
                        this.relevance.skillTags,
                        Array.from(this.relevance.selectedSkillTags)
                    ),
                },

                professorMetrics: {
                    // formerly professor
                    comment: this.professor.comment,
                    qualityTags: this.getDistributionObject(
                        this.professor.qualityTags,
                        Array.from(this.professor.selectedQualityTags)
                    ),
                },
				paid: false,

                text: this.comments.overallComment,
                tips: this.comments.adviceComment,
            };

            // Today's date
            const d = new Date();
            const ye = new Intl.DateTimeFormat("en", { year: "2-digit" }).format(d);
            const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
            const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
            obj.date = `${da}-${mo}-${ye}`;

            // Choose the full year format
            let yearOptions = [2020, 2019, 2018, 2017];
            obj.year = yearOptions[obj.overall.year - 1];

            let quarterOptions = ["Fall", "Winter", "Spring", "Summer"];
            obj.quarter = quarterOptions[obj.overall.quarter - 1];

            return obj;
        },

        getDistributionObject(keys, keysIndex) {
            // Set up a distribution object
            let obj = {};
            for (let key in keys) {
                obj[keys[key]] = 0;
            }

            // Turn on the ones in the array
            for (let index in keysIndex) {
                obj[keys[keysIndex[index]]] = 1;
            }

            return obj;
        },

        submit() {
            let obj = this.computeFormData();
            let reviewRef = firestore
                .collection("university").doc("uw")
                .collection("courses").doc(obj.course)
				.collection("reviews");

            // Show users a popup saying it is successful
            // and redirect
            reviewRef.add(obj).then(() => {
                this.showToast();
                this.$router.push("/courses/" + this.id);
            });

            // Post a Google Analytics update
            this.$gtag.event("button_click", {
                event_category: "Submit Button Clicked",
                event_label: "Add a Review",
                value: 0,
            });
        },
        showToast() {
            this.$toasted.success("Success!", {
                position: "top-center",
                duration: "2500",
                theme: "bubble",
                className: "success-toast",
            });
        },

        resetData() {
            this.onMenuClick = this.toggleMenuStyles;
            this.email = null;
            this.rating = {
                overall: 0,
                workload: 0,
                difficulty: 0,
                professor: 0,
                relevance: 0,
            };

            this.overall = {
                year: null,
                quarter: null,
                professor: null,
                grade: null,
            };

            this.workload = {
                hours: null,
                workTags: ["Homework", "Lectures", "Section", "Readings", "Office Hours", "Tests", "Other"],
                selectedWorkTags: new Set(),
            };

            this.difficulty = {
                comment: null,
            };

            this.relevance = {
                jobTags: [
                    "Software Engineer",
                    "Systems Engineer",
                    "Hardware Engineer",
                    "Data Scientist",
                    "Researcher",
                    "Not relevant",
                ],
                selectedJobTags: new Set(),
                skillTags: [
                    "Improved at interviewing",
                    "Helped with side projects",
                    "Sharpened fundamentals",
                    "Highly industry relevant",
                ],
                selectedSkillTags: new Set(),
            };

            this.professor = {
                comment: null,
                qualityTags: [
                    "Eager to help",
                    "Easy grader",
                    "Explains concepts easily",
                    "Extra credit opportunity",
                    "Energetic",
                    "Caring",
                    "Boring lectures",
                    "Very demanding",
                    "Harsh grader",
                    "Hard to follow along",
                    "Lots of busy work",
                ],
                selectedQualityTags: new Set(),
            };

            this.comments = {
                overallComment: null,
                adviceComment: null,
            };

            this.name = "a course";
            this.professors = [];
            this.menuOpen = false;
        },

        remount(course) {
            let coursesStore = firestore
                .collection("university")
                .doc("uw")
                .collection("courses");

            coursesStore
                .doc(course)
                .get()
                .then((doc) => {
                    // We got the data for this course!
                    if (doc.exists) {
                        let course = doc.data();
                        this.name = course.code;
                        this.id = doc.id;

                        // Make sure we have course data for each professor
                        course.professors.forEach((profId) => {
                            // Add all the professors
                            firestore
                                .collection("university")
                                .doc("uw")
                                .collection("professors")
                                .doc(profId)
                                .get()
                                .then((profDoc) => {
                                    if (profDoc.exists) {
                                        this.professors.push(profDoc.data());
                                    }
                                });
                        });
                    } else {
                        console.warn("No such document!");
                    }
                })
                .catch((error) => {
                    // Firebase could not connect
                    console.warn("Error getting document:", error);
                });

            // Return an array of bulmaCollapsible instances (empty if no DOM node found)
            this.collapsibles = bulmaCollapsible.attach(".is-collapsible");
            console.log(this.collapsibles);
        },

        // TODO: Improve to be something smoother
        handleHoursPerWeek() {
            if (this.workload.hours > 25) {
                this.workload.hours = 25;
            } else if (this.workload.hours < 0) {
                this.workload.hours = 0;
            }
        },
    },

    watch: {
        "$route.params.course": function(course) {
            this.resetData();
            this.remount(course);
            this.$forceUpdate();
        },
    },
    mounted() {

        // Check to see whether
        auth.onAuthStateChanged((user) => {
            if (user) {
                this.user = auth.currentUser;
                let course = this.$router.currentRoute.params.course;
                this.remount(course);
            } else {
                this.$router.push({ name: "login" });
            }
        });

    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_main.scss";

.section {
    padding: 25px 8%;

    &.mobile {
        padding: 0;
        margin: 0;
    }
}

textarea:focus,
input:focus {
    outline: none;
}

#landing-section {
    align-items: flex-end;
    width: 100%;
    min-height: 250px;
    padding: 0;
    margin: 0;
}

.course-bgd {
    height: fit-content;
    background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.14) 0%,
            rgba(255, 255, 255, 0.08) 13.02%,
            rgba(255, 255, 255, 0) 25%,
            rgba(255, 255, 255, 0) 79.69%,
            rgba(255, 255, 255, 0.08) 90.1%,
            rgba(255, 255, 255, 0.14) 100%
        )
        var(--bgd-color) top no-repeat;

    &.web {
        width: 100%;
        min-height: 200px;
        border-radius: 0 0 5rem 5rem;
    }

    &.mobile {
        width: 100%;
        position: absolute;
        top: 0;
        margin: 0;
        padding: 0;
        height: 220px;
        border-radius: 0 0 2rem 2rem;
    }
}

.course-landing {
    flex: 1;
    align-items: center;
    padding: 10px 10%;
}

.course-info {
    > * {
        color: white;
    }

    &.web {
        flex: 1;

        h1 {
            font-weight: 400;
        }
    }

    &.mobile {
        padding: 0 8%;
        max-width: calc(100% - 25px);
        width: 300px;

        h3 {
            line-height: 24px;
        }

        p {
            line-height: 0;
        }
    }
}

.course-bgd-footer {
    background: url("../assets/icons/other/code-icon.svg") repeat;
    height: 200px;
    width: 100%;
    opacity: 0.1;
    margin-top: -150px;
}

#hours-per-week-input {
    width: 75px;
    margin-left: 10px;
}

#progress-status {
    background-color: #fafafa;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 24px;
    max-width: 300px;
    width: 70%;
    position: --webkit-sticky;
    position: sticky;
    top: 24px;
    z-index: 10;
    margin-left: 20%;

    .progress-status-top > span {
        color: #e3c855;
        font-size: 36px;
    }

    .icon-container {
        display: flex;
        width: 70%;
        justify-content: space-between;
        margin: 20px 0;

        img {
            height: 25px;
        }

        .incomplete {
            opacity: 0.2;
        }
    }

    .submit-form {
        border-radius: 12px;
        width: 60%;
        display: table;
        margin: 0 auto;
        height: 48px;
        font-size: 16px;
        background-color: #fe5775;
        border: 1px solid #fe5775;
        color: white;
        outline: none;
        cursor: pointer;

        &:disabled {
            background-color: $lighter;
            color: rgba(0, 0, 0, 0.4);
            border: 1px solid lightgray;
        }

        &:hover:enabled {
            opacity: 0.8;
        }
    }
}

.divider {
    height: 1px;
    width: 95%;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 20px 0;
    margin-top: 35px;
}

.page-body-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.page-body-grid.section {
    margin: 75px 0 50px 0;
}

.page-body-item {
    grid-column-start: 1;
    grid-column-end: 3;
}

#all-metrics-input {
    a {
        text-decoration: none;
        color: black;
    }
}

.single-metric-input {
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fafafa;
    border-radius: 12px;
    padding: 36px;
    margin-bottom: 32px;
}

.single-metric-input {
    input {
        width: 75%;
    }
}

.accordion {
    .message-body-content {
        padding: 0;
    }

    .instruction {
        color: #999999;
        font-size: 14px;
        margin-left: 12px;
    }

    .question {
        border-radius: 12px;

        .chill {
            background-color: #33cef0;

            .description {
                background-color: #8fbedf;

                .fa-thumbs-down,
                .thumbs-down {
                    display: none;
                }
            }

            .justification {
                input {
                    background-color: #33cef0;
                }
            }
        }

        .rough {
            background-color: #fe5775;

            .description {
                background: linear-gradient(180deg, #fe5775 0%, #f98ea1 100%);

                .fa-thumbs-up,
                .thumbs-up {
                    display: none;
                }
            }

            .justification {
                input {
                    background-color: #fe5775;
                }
            }
        }

        .chill,
        .rough {
            display: flex;
            border-radius: 8px;

            .description {
                display: flex;
                flex-direction: column;
                align-items: center;
                color: #fafafa;
                border-radius: 8px;
                padding: 45px;
                font-size: 16px;
                font-weight: 700;

                .fa-thumbs-up,
                .fa-thumbs-down {
                    transform: scale(1.25, 1.25);
                    margin-bottom: 10px;
                }
            }

            .justification {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fafafa;
                width: 85%;

                > div {
                    width: 85%;
                    min-width: 150px;
                }

                .fa-quote-left {
                    margin: 0 20px;
                }

                .fa-check-circle {
                    margin-left: 20px;
                    transform: scale(1.25, 1.25);
                }

                input {
                    position: relative;
                    width: 85%;
                    color: white;
                    border-bottom: 1px solid white;
                }

                input::placeholder {
                    color: white;
                }
            }
        }

        p {
            font-size: 18px;
        }

        .question-posing-container {
            display: flex;
            align-items: center;
        }

        .optional-tag {
            display: inline;
            padding: 8px;
            background-color: #e3b4a5;
            color: white;
            font-size: 14px;
            border-radius: 4px;
            margin-left: 14px;
            height: 100%;
        }

        input {
            height: 30px;
            border: none;
            font-size: 16px;
            background-color: #fafafa;
            border-bottom: 1px solid #999999;
        }

        .tags-response {
            display: grid;
            grid-template-columns: repeat(2, 1fr); // not sure why this is two
            grid-auto-flow: column;

            > div {
                grid-column-start: 1;
                grid-column-end: 3;
                display: flex;
                flex-wrap: wrap;
                width: 100%;
            }

            .tag {
                position: relative;
                color: #999999;
                font-size: 14px;
                border: 1px solid #999999;
                background-color: #fafafa;
                border-radius: 12px;
                padding: 5px;
                text-align: center;
                margin: 5px;
                padding-left: 9px;
                padding-right: 9px;

                &:hover {
                    cursor: pointer;
                    opacity: 0.8;
                }

                &:focus {
                    outline: none;
                }

                &.active {
                    background-color: #e3c855;
                    color: white;
                    border: 1px solid #e3c855;
                }
            }
        }
    }
}

@media only screen and (max-width: $breakpoint-medium) {
    .accordion {
        .question {
            .tags-response {
                display: flex;
                flex-direction: column;

                > div {
                    grid-column-start: none;
                    grid-column-end: none;
                }
            }
        }
    }

    .page-body-item {
        position: relative;
        z-index: 10;
        top: 75px;
    }
}

@media only screen and (max-width: $breakpoint-large) {
    #progress-status {
        display: flex;
        position: fixed;
        bottom: 0;
        top: auto;
        left: 0;
        width: 100%;
        height: 10%;
        max-width: none;
        margin: 0;
        border-radius: 0;
        z-index: 20;

        > div {
            width: 40%;
        }

        .icon-container {
            display: none;
        }

        .progress-status-top {
            > span {
                font-size: 24px;
            }
        }

        .submit-form {
            width: 40%;
            margin-left: 10%;
        }
    }

    .page-body-grid {
        display: block;
        grid-template-columns: none;
    }

    .page-body-item {
        grid-column-start: none;
        grid-column-end: none;
    }

    .accordion {
        .question {
            .optional-tag {
                padding: 4px;
                font-size: 12;
            }
        }
    }

    #comments {
        input {
            width: 100%;
        }
    }

    .single-metric-input {
        input[type="text"] {
            font-size: 14px;
        }
    }

    .accordion {
        .question {
            .chill,
            .rough {
                padding: 36px;

                > .description {
                    display: none;
                }

                .justification {
                    display: flex;
                    flex-direction: column;
                    align-items: end;
                    width: 100%;

                    > div {
                        width: 100%;
                    }

                    .fa-quote-left {
                        margin: 0;
                    }

                    .fa-check-circle {
                        display: none;
                    }
                }
            }
        }
    }
}
</style>
